<template>
  <b-modal
    v-model="showModal"
    :title="title"
    :size="size"
    :header-bg-variant="propHeaderBgVariant"
    :header-text-variant="propHeaderTextVariant"
    :hide-header="propHideHeader"
    :hide-footer="true"
    @hidden="onModalHidden"
    @ok="handleOk"
    @cancel="handleCancel">
    <div>
      <slot />
    </div>
    <footer v-if="!hideFooter"
            class="mt-3">
      <hr>
      <div 
        class="d-flex justify-content-end">
        <CustomButton :text="titleButtonCancel ? titleButtonCancel : 'Cancelar'"
                      variant="light"
                      @click="handleCancel" />
        <CustomButton class="ml-3"
                      :text="titleButton ? titleButton : 'Confirmar'"
                      :disabled-button="disabledButton"
                      @click="handleOk" />
      </div>
    </footer>
  </b-modal>
</template>

<script>
  import CustomButton from '@/components/CustomButton/CustomButton.vue'
  export default {
    name: 'CustomModal',
    components: {
      CustomButton
    },
    props: {
      title: {type: String, default: ""},
      titleButton: {type: [String, Boolean], default: false},
      titleButtonCancel: {type: [String, Boolean], default: false},
      disabledButton: { type: Boolean, default: false },
      hideFooter: { type: Boolean, default: false },
      show: { type: Boolean, default: false, require: true },
      disable: { type: Boolean, default: false },
      size: { type: String, default: 'lg' },
      color: { type: String, default: '' },
      variants: { type: String, default: 'primary' },
      hideBackdrop: { type: Boolean, default: false },
      propHeaderBgVariant: { type: String, default: 'secondary' },
      propHeaderTextVariant: { type: String, default: 'white' },
      propHideHeader: { type: Boolean, default: false },

    },
    data () {
      return {
        showModal: false,
        seloToExclude: [],
        resolveModal: null
      }
    },
    watch: {
      show () {
        if (this.show) this.showModal = true
        else this.showModal = false
      }
    },
    created () {
      this.showModal = this.show   
    },
    methods: {
      hide () {
        this.$emit('closeModal')
      },
      handleOk () {
        this.$emit("ok")
      },
      handleCancel () {
        this.$emit("cancel")
        this.hide()
      },
      onModalHidden () {
        this.$emit('closeModal')
      },
    }
  }
</script>
